import { useResponsive } from '@dustin-web/microsite-components/src/hooks'
import Card from './product-card'
import type { Props } from '../product-card-gallery'
import dynamic from 'next/dynamic'

const ProductAccessoriesCard = dynamic(
  () => import('../productAccessories/product-accessories-card')
)

export default function Container(props: Props) {
  const { breakpoints } = useResponsive()

  if (breakpoints.max.SM) {
    return <ProductAccessoriesCard {...props} breakpoints={breakpoints} />
  } else {
    return <Card {...props} breakpoints={breakpoints} />
  }
}
